// extracted by mini-css-extract-plugin
export default {"progressbar":"styles_progressbar__HkjUY","change":"styles_change__-QhYr"};